import { useEffect } from "react";
import { APIProvider, Map, useMap } from "@vis.gl/react-google-maps";

const KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

export const WARN_COLORS = { 1: "#FF3B30", 6: "#f59e0b", 7: "#f97316", 8: "#b91c1c", 9: "#eab308", 14: "#6b7280" };
export const WARN_LETTER = { 1: "A", 6: "J", 7: "L", 8: "C", 9: "W", 14: "B" };

export const GoogleMapShell = ({ children, height = "100%", theme = "light", interactive = true, gesture }) => {
  if (!KEY) {
    return <div style={{ height, width: "100%" }} className="flex items-center justify-center text-sm text-muted-foreground bg-muted/40">Google Maps API key not configured</div>;
  }
  return (
    <APIProvider apiKey={KEY}>
      <Map
        key={theme}
        style={{ width: "100%", height }}
        defaultCenter={{ lat: 53.5, lng: -1.9 }}
        defaultZoom={6}
        mapId="DEMO_MAP_ID"
        colorScheme={theme === "dark" ? "DARK" : "LIGHT"}
        gestureHandling={gesture || (interactive ? "greedy" : "none")}
        disableDefaultUI={!interactive}
        zoomControl={interactive}
        mapTypeControl={false}
        streetViewControl={false}
        fullscreenControl={false}
        clickableIcons={false}
      >
        {children}
      </Map>
    </APIProvider>
  );
};

export function GTrafficLayer() {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google) return;
    const layer = new window.google.maps.TrafficLayer();
    layer.setMap(map);
    return () => layer.setMap(null);
  }, [map]);
  return null;
}

export function GPolyline({ path, color = "#0A84FF", weight = 5, opacity = 0.95, zIndex = 1 }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google || !path?.length) return;
    const line = new window.google.maps.Polyline({
      path: path.map((p) => (Array.isArray(p) ? { lat: p[0], lng: p[1] } : p)),
      strokeColor: color,
      strokeWeight: weight,
      strokeOpacity: opacity,
      zIndex,
      map,
    });
    return () => line.setMap(null);
  }, [map, path, color, weight, opacity, zIndex]);
  return null;
}

export function FitBounds({ points, padding = 40 }) {
  const map = useMap();
  useEffect(() => {
    if (!map || !window.google || !points?.length) return;
    const b = new window.google.maps.LatLngBounds();
    points.forEach((p) => b.extend(Array.isArray(p) ? { lat: p[0], lng: p[1] } : p));
    map.fitBounds(b, padding);
  }, [map, points, padding]);
  return null;
}

export const NumPin = ({ label, bg = "#FF3B30", size = 26 }) => (
  <div style={{ background: bg, color: "#fff", width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: Math.round(size * 0.46), fontFamily: "monospace", border: "2px solid #fff", borderRadius: "50%", boxShadow: "0 0 6px rgba(0,0,0,.6)" }}>
    {label}
  </div>
);

export const WarnPin = ({ cat, size = 20 }) => (
  <div style={{ background: WARN_COLORS[cat] || "#f59e0b", color: "#fff", width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontSize: Math.round(size * 0.5), fontFamily: "monospace", border: "2px solid #fff", borderRadius: 3, boxShadow: "0 0 5px rgba(0,0,0,.5)" }}>
    {WARN_LETTER[cat] || "!"}
  </div>
);

export const VanPin = ({ size = 30 }) => (
  <div style={{ background: "#0A84FF", border: "2px solid #fff", borderRadius: "50%", width: size, height: size, display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 10px rgba(10,132,255,.8)" }}>
    <svg width={size * 0.53} height={size * 0.53} viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
      <path d="M15 18H9" />
      <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </svg>
  </div>
);
